<script setup lang="ts">
import type { CvVariant } from '@/utils/cvVariant'

withDefaults(defineProps<{ variant?: CvVariant }>(), {
  variant: 'canonical',
})
</script>

<template>
  <template v-if="variant === 'anthropic'">
    <p>
      Principal Platform Engineer with over 25 years across software, systems, and cloud engineering,
      specialising in developer productivity, CI/CD architecture, shared tooling, and infrastructure platforms.
    </p>
    <p>
      At DAA, through Bitheater Ltd, I shape platform architecture and engineering practices for cloud-based
      applications, combining cross-team technical leadership with hands-on software and infrastructure
      development. Previously, at Parser supporting British Airways,
      I owned platform architecture and roadmap across 6 applications, 25 repositories, 24 services,
      60 Dagster pipelines and 24 AWS accounts used by 36 engineers.
    </p>
    <p>
      My experience includes GitHub Actions and Jenkins platforms, monorepo development and repository
      migrations, end-to-end test automation, Python and TypeScript services, container platforms, and hands-on
      technical leadership across ambiguous, multi-team initiatives.
    </p>
  </template>
  <template v-else>
    <p>
      I build secure, reusable cloud platforms that help engineering teams deliver software reliably and
      efficiently. My background spans over 25 years of software engineering, systems administration, cloud
      infrastructure and hands-on technical leadership.
    </p>
    <p>
      As a Principal Platform Engineer at DAA through Bitheater Ltd, I shape platform architecture and
      engineering practices for cloud-based applications, combining cross-team technical leadership with
      hands-on software and infrastructure development.
    </p>
    <p>
      Previously, at Parser supporting British Airways, I led platform architecture and standards across
      6 applications, 25 repositories, 24 services, 60 Dagster pipelines and 24 AWS accounts supporting
      36 engineers. This combined reusable Terraform modules, delivery workflows and local-development
      tooling for React, FastAPI and Dagster applications on AWS ECS Fargate.
    </p>
    <p>
      I provide technical mentorship across teams and contribute to technical assessments during engineer
      selection. I am based in Castellón, Spain, open to relocating to London, and require UK Skilled Worker
      sponsorship.
    </p>
  </template>
</template>
